module.exports = __webpack_public_path__ + "img/paper.c3effe91.svg";